var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center"},[_c('BaseIcon',{staticClass:"text-primary-400 text-5xl mt-5",attrs:{"icon":"exclamation-triangle"}}),_c('h2',{staticClass:"font-bold text-3xl text-primary-400 mt-5 mb-2"},[_vm._v("404! Not Found")]),_c('p',{staticClass:"italic"},[_vm._v("Begärda webbadressen hittades inte")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }